/* template */
<template><div :class='("packet "+(template))' :style="[(bgStyle)] | transRpxStyle"><div class="coupon-area"><div v-for="(item, index) in (couponInfoNew)" :key="item['{{product_id}}']" class="coupon"><div :style="[(product_line_tag[item.product_id])] | transRpxStyle" class="tag">{{product_line_tag_text[item.product_id]}}</div><div class="award"><div class="mark">{{item.coupon.type_name}}</div><div class="amount">{{item.coupon.max_benefit_capacity.value}}</div><div class="unit">{{item.coupon.max_benefit_capacity.unit}}</div></div><div class="desc">以实际领取为准</div></div></div><mpx-image src="https://ut-static.udache.com/webx/ut/gXEUp_0RsGEpem7kPa2gM.png" class="coupon-cover"></mpx-image><mpx-button @tap="click" class="btn">{{ btnText }}</mpx-button></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m329ca790"}'>
// 元折去打车周一二三四五六日可领券包立即取每天都能领打车神券保存海报 !  明天再领 !  每天可领 !打车前必领！!
@font-face {
  font-family: MF-YuanHei-Regular-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/xmmOMLyVhv6MwG1Go8EeX.ttf')
}

// 01234567890¥$
@font-face {
  font-family: UniSansHeavyCAPS-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/E6djY8wJ1nmhOoqWEfB-m_Uni-Sans-Heavy.ttf')
}
  .packet
    display flex
    position relative
    justify-content center
    box-sizing: border-box;
    width 750rpx
    height 560rpx
    background-size: 100% 100%
    background-image: url('https://ut-static.udache.com/webx/ut/tQhjiQMSE4dlrzpBIRlLX.png')
    background-repeat: no-repeat
    overflow hidden
    margin-top 227rpx
    .coupon-cover
      position absolute
      bottom 0
      width 700rpx
      height 250rpx
    .coupon-area
      display flex
      justify-content center
      align-items center
      .coupon
        width 224rpx
        height 334rpx
        background-image url('https://ut-static.udache.com/webx/ut/jNgH89VIvOP45_rNFU-P1.png')
        background-size 100% auto
        background-repeat no-repeat
        position relative
        display flex
        flex-direction column
        align-items center
        .tag
          position absolute
          top 0
          width: 161rpx
          height: 43rpx
          line-height: 43rpx
          background-size: 100% auto;
          background-repeat: no-repeat;
          font-family: PingFangSC-Medium;
          font-size: 20rpx;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
        .award
          position absolute
          top 47rpx
          display flex
          align-items: baseline;
          .mark
            width 38rpx
            height 18rpx
            line-height 18rpx
            position absolute
            right -10rpx
            top 10rpx
            font-family: PingFangSC-Regular;
            font-size: 14rpx;
            color: #FEF1D6;
            text-align: center;
            font-weight: 400;
            border: 1rpx solid #FEEFD0;
            border-radius: 10rpx;
          .amount
            height: 80rpx;
            font-family: UniSansHeavyCAPS, UniSansHeavyCAPS-self;
            font-size: 80rpx;
            color: #FEEFD0;
            letter-spacing: -2rpx;
            text-align: center;
            font-weight: 900;
          .unit
            width: 32rpx;
            height: 30rpx;
            font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
            font-size: 29.4rpx;
            color: #FEEFD0;
            letter-spacing: 2.2rpx;
            text-align: center;
            font-weight: 900;
        .desc
          position absolute
          bottom 110rpx
          width: 120px;
          height: 33rpx;
          font-family: PingFangSC-Medium;
          font-size: 24rpx;
          color: #FFF3D8;
          letter-spacing: 0;
          text-align: center;
          text-shadow: 0 1rpx 0 #BD2715;
          font-weight: 500;
    .btn, .limit
      position absolute
      left 50%
      transform translate(-50%)
    .btn
      background-image: url('https://ut-static.udache.com/webx/ut/TXtJ0fIFo4BH96D8zB8j3.png');
      background-size: 100% auto
      background-repeat: no-repeat
      bottom: 0
      width 540rpx
      height 160rpx
      line-height 120rpx
      font-size: 48rpx;
      font-family: PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      text-align center
      margin-bottom 0
      letter-spacing 1.71rpx
      background-color: transparent
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m329ca790"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./red-packet-close.mpx.js?isComponent&outputPath=components%2Fred-packet-close329ca790%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./red-packet-close.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fred-packet-close329ca790%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m329ca790"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/red-packet-close329ca790/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
